import React, {ChangeEvent, FunctionComponent, useContext, useEffect, useState} from 'react';
import {AutoExpandableTextarea} from "../AutoExpandableTextarea/AutoExpandableTextarea";
import {Button} from "../ui-components/Button/Button";
import './CommentCreate.scss';
import {ToastService} from "../../service/ToastService";
import {PreviewDataContext} from "../../context/PreviewContext";

interface CommentTileProps {
    onCreateComment: (text: string) => void;
}

export const CommentCreate: FunctionComponent<CommentTileProps> = (props) => {
    const [text, setText] = useState<string>('');
    const previewContext = useContext(PreviewDataContext);

    const createComment = () => {
        if (previewContext.isPreviewMode) {
            ToastService.middleScreenWarningToast('This button is not available in preview mode.');
            return;
        }
        props.onCreateComment(text);
        setText('');
    }

    return (
        <div className='comment-create-section'>
            <div className="form-group">
                <div className="input-container">
                    <label>Comment:</label>
                    <AutoExpandableTextarea value={text} initRows={2} maxRows={10}
                                            onChange={(event: ChangeEvent) => setText((event.target as HTMLTextAreaElement).value)}/>
                </div>
            </div>

            <div className="form-group center-align">
                <div className="input-container">
                    <Button onClick={createComment}>Add Comment</Button>
                </div>
            </div>
        </div>
    );
};
